import React, {Component} from "react";
import {LearnBox} from "./LearnBox";
import {getPoints} from "../services/UserStatsService";

export class GameBox extends Component {
    render() {
        let {children, title, currentGameNumber, currentGameText, subjectKey} = this.props;
        const points = getPoints(subjectKey);
        const currentGame = currentGameText ? <div className="col col1">
            {currentGameText}:
            <span className="number"> {currentGameNumber}</span>
        </div> : null;
        return <LearnBox title={title}>
            {children}
            <div className="container game-box">
                <div className="row">
                    {currentGame}
                    <div className="col col2">
                        Points:
                        <span className="number"> {points}</span>
                    </div>
                </div>
            </div>
        </LearnBox>;
    }
}